<div class="app-container">
  <div class="app-content">
    <div class="home">
      <a mat-icon-button  class="phone" href="tel:1-609-888-6039"><mat-icon>phone_enabled</mat-icon></a>
      <img src="./assets/doc.jpg" class="doc-background"/>
      <div [ngClass]="getPanelClass()" >
        <div class="question-container" *ngIf="wizard && wizard.answerable && currentQuestion > -1 && isEnd()">
          <div class="question-header">You're all set!</div>
          <img class="all-set" src='assets/conversing-docs.png'/>
          <div class="question-small" *ngIf="wizard && wizard.answerable && currentQuestion > -1">
            {{wizard.answerable.intro}}
          </div>
          <div class="button-container">
            <button class="extra-rounded-button" mat-flat-button color="primary" (click)="goBack()">Go back</button>
          </div>
        </div>
        <div class="question-container" *ngIf="wizard && wizard.answerable && currentQuestion > -1 && !isEnd() && isPromisLoaded()">
          <div [ngClass]="getQuestionClass()" *ngIf="wizard && wizard.answerable && currentQuestion > -1">
            {{getQuestionText()}}
          </div>
          <div class="button-container" *ngIf="wizard && wizard.answerable && currentQuestion > -1 && getQuestions()[currentQuestion]">
            <span *ngFor="let b of getQuestions()[currentQuestion].answers" >
              <button *ngIf="!isSelected(b.button)" color="primary" class="extra-rounded-button"  mat-flat-button  (click)="doAnswer(b.button)">{{b.button}}</button>
              <button *ngIf="isSelected(b.button)" class="extra-rounded-button"  mat-stroked-button  (click)="doAnswer(b.button)">{{b.button}}</button>
            </span>
      
          </div>
        </div>
        <div class="footer" *ngIf="wizard && wizard.answerable && currentQuestion > -1 && isPromisLoaded()">
          <div class="nav-bar">
            <button mat-button class="nav-button" (click)="setToQuestion(currentQuestion-1)"><span  *ngIf="currentQuestion > 0">Previous</span>&nbsp;</button>
            <button mat-button class="nav-button">&nbsp;<span *ngIf="currentQuestion < getQuestions().length"  (click)="setToQuestion(currentQuestion+1)">Next</span></button>
          </div>
          <div    class="dotProgress">
            <div *ngFor="let q of getQuestions(); let n = index">
                <div [ngClass]="{'filledDot': shouldFill(n), 'unfilledDot': !shouldFill(n)}"></div>
            </div>
          </div>
          <div class="powered-by">Powered by Huddy Health LLC</div>
        </div>
      </div>
    </div>
</div>
<canvas class="cvs" #measurementCanvas></canvas>